/* src/app/views/template/components/edit-template-menu/edit-template-label-stack-menu/edit-template-label-stack-menu.component.scss */
/*# sourceMappingURL=edit-template-label-stack-menu.component.css.map */
